import { FC, useEffect } from 'react';
import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { useReferralDispatch, useReferralStore } from '@/components/Referral/ReferralProvider';
import getLocal from '@/app/utils/getLocal';

interface TermsProps {
    selfFetch?: boolean;
}
const Terms: FC<TermsProps> = ({ selfFetch = false }) => {
    const { useLang, useRouter } = useGlobal();
    const { referralInfo } = useReferralStore();
    const { pathname, query } = useRouter();
    const { locale } = getLocal();

    let path = `/${locale}${pathname}`;

    const { t } = useLang('referral');
    const dispatch = useReferralDispatch();

    // pathname 优先，query 参数次优先
    const isReceive = pathname === '/referral-rewards' || pathname === '/members-festival-referral' || query?.type === 'receive';

    if (selfFetch) {
        useEffect(() => {
            if (pathname === '/referral-terms') {
                path = query?.type === 'receive' ? `/${locale}/referral` : `/${locale}/referral-rewards`;
            }
            dispatch({ type: 'getReferralInfo', payload: { locale, path } });
        }, []);
    }

    return (
        <div className={`${styled.terms} ${selfFetch ? styled.selfFetch : ''}`}>
            <div className="content ">
                <h5 className="title">{t('terms.title')}</h5>
                {isReceive ? (
                    <div className="desc" dangerouslySetInnerHTML={{ __html: referralInfo?.receiveTc || '' }}></div>
                ) : (
                    <div className="desc" dangerouslySetInnerHTML={{ __html: referralInfo?.shareTc || '' }}></div>
                )}
            </div>
        </div>
    );
};

export default Terms;
